module.exports = __webpack_public_path__ + "static/canvasLogoMin.85137cb7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/canvasLogoMin.jpg
// module id = 415
// module chunks = 79611799117203